import pluralize from "pluralize";
import React from "react";

const joiner = (courses, conjunction) => {
  const { length } = courses;
  const lastDelimiter = length < 2 ? "" : conjunction;
  const lastCourse = courses.pop();

  return [courses.join(", "), lastCourse].join(lastDelimiter);
};

const random = () => Math.random().toString(36);

const roundsListItem = (roundsText, courses) => {
  const key = courses.replace(" ", "-");

  return (<li key={key}><i className="fa fa-flag fa-li"></i>{roundsText} at {courses}</li>);
};

const allocatedRoundsOld = allocated => allocated.map(({ name, rounds }) =>
  roundsListItem(pluralize("round", rounds, true), name)
);

const allocatedRoundsNew = allocated => allocated.map(text => <li key={`allocated-${random()}`}><i className="fa fa-flag fa-li"></i>{text}</li>);


const allocatedRounds = allocated => {
  if (!allocated || !allocated.length) {
    return null;
  }

  if (allocated.some(item => typeof item !== "string")) {
    return allocatedRoundsOld(allocated);
  }

  return allocatedRoundsNew(allocated);
};

const unallocatedRoundsOld = unallocated => {
  if (!unallocated.rounds) {
    return null;
  }

  const courses = unallocated.courses.map(({ name }) => name);
  const roundsText = pluralize("round", unallocated.rounds, true);

  return roundsListItem(roundsText, joiner(courses, " or "));
};

const unallocatedRoundsNew = unallocated => <li key="unallocated"><i className="fa fa-flag fa-li"></i>{unallocated}</li>;

const unallocatedRounds = unallocated => {
  if (!unallocated) {
    return null;
  }

  if (typeof unallocated !== "string") {
    return unallocatedRoundsOld(unallocated);
  }

  return unallocatedRoundsNew(unallocated);
};

const unlimitedRoundsOld = unlimited => {
  const courses = unlimited.map(({ name }) => name);

  return roundsListItem("Unlimited rounds", joiner(courses, " and "));
};

const unlimitedRoundsNew = unlimited => <li key="unlimited"><i className="fa fa-flag fa-li"></i>{unlimited}</li>;

const unlimitedRounds = unlimited => {
  if (!unlimited || !unlimited.length) {
    return null;
  }

  if (typeof unlimited !== "string") {
    return unlimitedRoundsOld(unlimited);
  }

  return unlimitedRoundsNew(unlimited);
};

const PackageFeatures = props => {
  const { boardBasis, notes, roundsDetails } = props;
  return (
    <ul className="icon-list icon-list--yellow" data-component="offer-list">
      {boardBasis && <li><i className="fa fa-bed fa-li"></i>{boardBasis}</li>}
      {allocatedRounds(roundsDetails.allocated)}
      {unallocatedRounds(roundsDetails.unallocated)}
      {unlimitedRounds(roundsDetails.unlimited)}
      {notes && notes.map((note, index) => {
        // eslint-disable-next-line react/no-array-index-key
        return (<li key={`note-${index}`}><i className="fa fa-check-circle-o fa-li"></i>{note}</li>);
      })}
    </ul>
  );
};

export default PackageFeatures;



// WEBPACK FOOTER //
// ./components/search/package/PackageFeatures.jsx